import { c as _c } from "react/compiler-runtime";
import React from "react";

// Simple shimmer effect
const shimmerStyle: React.CSSProperties = {
  background: "linear-gradient(90deg, #f3f3f3 25%, #e0f7f4 50%, #f3f3f3 75%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite linear"
};

// Add shimmer keyframes to the page (if not already present)
if (typeof window !== "undefined") {
  const styleId = "explore-flavors-shimmer-keyframes";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = `@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }`;
    document.head.appendChild(style);
  }
}
const SectionHeadingLoader: React.FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="shrink-0 lg:mr-4"><div className="whitespace-nowrap text-center font-lora uppercase tracking-normal text-[#005F52] text-xl font-semibold leading-none lg:text-left lg:text-4xl lg:leading-10" style={{
        ...shimmerStyle,
        width: 180,
        height: 32,
        borderRadius: 8
      }} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center gap-2 lg:flex-row lg:justify-between lg:items-end lg:mb-4">{t0}<div className="hidden lg:flex items-center gap-2 w-full"><div className="bg-[#ebf8f6] flex-1 h-[1px] lg:min-w-[400px]" style={shimmerStyle} /><div className="flex justify-center items-center w-4 h-4 text-[#037A6A] lg:w-5 lg:h-5" style={shimmerStyle} /><div className="bg-[#ebf8f6] flex-1 h-[1px] lg:min-w-[400px]" style={shimmerStyle} /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div>{t1}<div className="hidden lg:block text-center font-lora text-[#3E4946] mt-1 mb-4 text-sm font-semibold leading-5 lg:text-left lg:mt-2 lg:mb-0 lg:text-base lg:font-normal lg:leading-6" style={{
        ...shimmerStyle,
        width: 220,
        height: 20,
        borderRadius: 8
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default SectionHeadingLoader;